import axios from "axios";

export async function getGmapPlace(query: string): Promise<any> {
    return await axios({
        url: `https://places.googleapis.com/v1/places:searchText`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Goog-Api-Key": import.meta.env.VITE_GOGLE_MAP_API_KEY || "",
            "X-Goog-FieldMask": "places.displayName,places.formattedAddress,places.location,places.googleMapsUri,places.addressComponents"
        },
        data: {
            textQuery: query
        }
    });
}